import service from './api.services';

const buscarUrlAcessoFichaImovel = async (idProcesso) => {
    const response = await service.get(`/api/ficha-imovel/${idProcesso}`);
    return response.data;
};

export {
    buscarUrlAcessoFichaImovel
};
